<template>
    <div class="grid-container"
        :style="`grid-template-columns: minmax(120px, auto) repeat(${globalState.observations.length}, auto)`">
        <div></div>

        <div v-for="observation in globalState.observations" v-bind:key="observation.shortname" class="header-rotated">
            <span>{{
                observation.name }}</span></div>

        <ObservationRow v-for="p in allParticipants" :key="p.key" :participant="p"
            @observation-changed="onObservationChanged" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import _ from 'lodash';
import ObservationRow from "@/components/classroom/sidePanel/observations/ObservationRow.vue";
import { globalState } from '@/scripts/store';

const emit = defineEmits(['observationChanged']);

const props = defineProps({
    participants: Object,
    expectedParticipants: Object,
});

const allParticipants = computed(() => {
    var missing,
        found,
        result;

    if (!props.expectedParticipants) {
        result = props.participants;
    }
    else if (!props.participants || props.participants.length === 0) {
        result = props.expectedParticipants;
    }
    else {
        // Merge participants and expectedParticipants userData
        result = [];
        for (var ep of props.expectedParticipants) {
            found = false;
            for (var p of props.participants) {
                if (p.userData?.studentUuid === ep.userData?.studentUuid) {
                    p.userData = _.merge(p.userData, ep.userData);
                    found = true;
                    break;
                }
            }

            if (!found) {
                missing = missing || [];
                missing.push(ep);
            }
        }

        // Sort alphabetically by name
        result = _.sortBy(missing ? _.concat(props.participants, missing) : props.participants, (a) => { return a?.user_name });
    }

    return result;
});

function onObservationChanged(data) {
    emit('observationChanged', data);
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.observation-header {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0.5vh 0;
    justify-content: right;

    li {
        input {
            margin: 0 5px;
        }
    }

    &-col {
        width: 30px;
        text-align: center;
        cursor: default;
    }
}


/* 1. Define the 5-column grid layout */
.grid-container {
    display: grid;
    /* 1 auto column for names, 4 equal columns for checkboxes */
    grid-template-columns: minmax(120px, auto) repeat(4, auto);
    gap: 5px;
    align-items: center;
    font-family: sans-serif;
}

/* 2. Rotate the headers 270 degrees */
.header-rotated {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    /* Aligns text to the bottom of the header cell */
    height: 120px;
    /* Give enough height for the rotated text */
    padding-bottom: 5px;
}

.header-rotated span {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    /* Flips vertical-rl to read bottom-to-top (270°) */
    white-space: nowrap;
    max-height: 120px;
    /* 1. Limit the vertical height to 100px */
    overflow: hidden;
    /* 2. Hide whatever spills past 100px */
    text-overflow: ellipsis;
}

/* 3. Style student names and checkbox cells */
.student-name {
    font-weight: bold;
    text-align: right;
    padding-right: 10px;
}

.grid-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

/* Optional: Add subtle borders for a cleaner sheet look */
.grid-container>div {
    padding: 5px;
}
</style>